import {
  formatCurrency,
  useListPager,
} from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import { BoxIcon } from '@airship-platform/jam-web/icons';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Product, useProducts } from '../../data-access';
import ProductCard from './ProductCard';

interface ProductCardWithActionsProps {
  children: (product: Product) => React.ReactNode;
  showDescription?: boolean;
}

const ProductCardWithActions: React.FC<ProductCardWithActionsProps> = ({
  children,
  showDescription,
}) => {
  const [pageCounter, setPageCounter] = useState(20);

  const { products } = useProducts();

  const { loaderRef } = useListPager({
    incrementBy: 20,
    initialValue: pageCounter,
    maxValue: products.length,
    callbackFn: setPageCounter,
  });

  const pagedProducts = products.slice(0, pageCounter);

  return (
    <FlexBox flexDirection={'column'} gap={2} width={'100%'}>
      {pagedProducts.map((product) => (
        <ProductCard
          key={product.pricebookId}
          product={product}
          noImageIcon={<BoxIcon />}
          showDescription={showDescription}
          priceSection={
            <>
              {product.prices
                .filter((p) => p.priceType === product.defaultPriceType)
                .map((p) => (
                  <Typography key={p.priceType} variant="body2">
                    {formatCurrency(p.value, p.currency)}
                  </Typography>
                ))}
            </>
          }
        >
          {children(product)}
        </ProductCard>
      ))}
      <Box ref={loaderRef} sx={{ height: 50 }} />
    </FlexBox>
  );
};

export default ProductCardWithActions;
